import { authRouteConstants } from "constants/routeConstants"
import { useEffect } from "react"
import { updateUserDetail } from 'utils/auth';
import { useNavigate } from "react-router-dom";
import { useCart } from "utils/CartContext";

const Logout = () => {
    
    const { messagefroAuth,setmessagefroAuth, couponctx, orderNotesctx,setOrderNotes, updateCouponctx, saveNotectx } = useCart();
    const navigate = useNavigate();

    const doLogout = () => {
        updateUserDetail()
        localStorage.removeItem('u-access-token')
        localStorage.removeItem('u-refresh-token')
        localStorage.removeItem('u_user_data')
        localStorage.removeItem('vouchercode')
        localStorage.removeItem('localNotes')
        updateCouponctx("")
        setOrderNotes({})
        navigate(authRouteConstants.HOME)
    }

    useEffect(() => {
        doLogout();
    }, [])
}

export default Logout